<template>
    <div class="role">
        <div class="role-box">
            <div class="role-box-list"
                 v-for="(item,index) in menu"
                 :key="index"
                 :class="menuActive===index?'role-box-active':''"
                 @click="menuChange(index)">{{item.name}}<span></span><samp><i
                       class="iconfont icondagouicon-16"></i></samp></div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'role',
    props: ['cutList'],
    data () {
        return {
            menuActive: '',
            menu: [
                { name: '领导/督导', prop: 'SUPERVISOR_OR_LEADER_PC' },
                { name: '教师', prop: 'TEACHER_PC' },
                { name: '教学秘书', prop: 'SECRETARY_PC' },
            ]
        }
    },
    computed: {
        ...mapGetters([
            'commonality'
        ])
    },
    created () {
        let val = ''
        this.menu = (this.cutList || this.commonality.headerList).map((r, i) => {
            if (r.identity === 'TEACHER_PC') {
                r.name = '教师'
            } else if (r.identity === 'SUPERVISOR_OR_LEADER_PC') {
                r.name = '领导/督导'
            } else if (r.identity === 'SECRETARY_PC') {
                r.name = '教学秘书'
            }
            if (r.defaultIdentity === 'YES') {
                val = r.identity
            }
            r.prop = r.identity
            return r
        })

        this.menuActive = this.menu.findIndex(r => r.prop === (this.commonality.identity || val))
    },
    methods: {
        ...mapActions([
            'set_commonality'
        ]),
        menuChange (index) {
            if (this.menuActive === index) return
            this.menuActive = index
            let identity = this.commonality.headerList.filter(item => {
                return item.identity === this.menu[index].prop
            })
            this.set_commonality({ identityObj: identity[0] })
        }
    },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
.role {
    &-box {
        padding: 0.24rem
        &-list {
            // width: 100%;
            height: 0.64rem
            line-height: 0.64rem
            text-indent: 0.24rem
            background: #F2F7F7
            border: 1px solid #DBDBDB
            color: #333333
            font-size: 0.16rem
            cursor: pointer
            >span, >samp {
                display: none
            }
        }
        &-active, &-list:hover {
            border: 1px solid #2396F5
            background-color: #FFFFFF
            position: relative
            >span {
                position: absolute
                display: inline-block
                right: 0
                bottom: 0
                width: 0
                height: 0
                border-bottom: 0.4rem solid #2396F5
                border-left: 0.4rem solid transparent
                z-index: 1
            }
            >samp {
                position: absolute
                display: inline-block
                right: 11px
                bottom: 0
                color: #ffffff
                z-index: 2
                width: 0.3rem
                height: 0.3rem
                line-height: 0.3rem
            }
        }
        &-list:hover {
            opacity: 0.7
        }
        &-list:active {
            opacity: 0.9
        }
        &-list {
            margin-bottom: 0.16rem
        }
        &-list:last-child {
            margin-bottom: 0
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/main/alter-role.vue